import React from 'react';
import PropTypes from 'prop-types';
import Image from '@tcp/core/src/components/common/atoms/Image';
import { getImageFilePath } from '@tcp/core/src/utils';

export const UserIcon = ({ brand }) => {
  return (
    <span
      className={`svg-icon-wrapper user-icon active-brand-${brand}`}
      tabIndex="0"
      aria-label="user-icon"
      role="link"
    >
      <svg viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20.9993" cy="21" r="21" fill="#F5F5F5" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.4249 8.8421C17.9031 8.8421 15.0481 11.6971 15.0481 15.2188C15.0481 18.7406 17.9031 21.5956 21.4249 21.5956C24.9467 21.5956 27.8016 18.7406 27.8016 15.2188C27.8016 11.6971 24.9467 8.8421 21.4249 8.8421ZM21.4253 10.2073C24.1878 10.2073 26.4356 12.4551 26.4356 15.2176C26.4356 17.9801 24.1878 20.2279 21.4253 20.2279C18.6628 20.2279 16.415 17.9801 16.415 15.2176C16.415 12.4551 18.6628 10.2073 21.4253 10.2073Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.3618 30.9474C30.98 30.9474 30.671 30.6449 30.671 30.2722C30.671 27.1695 26.3327 24.6457 20.9996 24.6457C15.6666 24.6457 11.3282 27.1695 11.3282 30.2722C11.3282 30.6449 11.0192 30.9474 10.6374 30.9474C10.2556 30.9474 9.94662 30.6449 9.94662 30.2722C9.94662 26.425 14.9053 23.2953 20.9996 23.2953C27.094 23.2953 32.0527 26.425 32.0527 30.2722C32.0527 30.6449 31.7436 30.9474 31.3618 30.9474Z"
          fill="black"
        />
      </svg>
    </span>
  );
};

export const StorePin = ({ brand }) => {
  return (
    <span
      className={`svg-icon-wrapper  store-icon active-brand-${brand}`}
      tabIndex="0"
      aria-label="store-icon"
      role="link"
    >
      <svg viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20.9993" cy="21" r="21" fill="#F5F5F5" />
        <path
          d="M20.7352 9.94736C22.1947 9.94794 23.63 10.3126 24.9053 11.0069C26.1806 11.7012 27.2538 12.7022 28.0234 13.9151C28.793 15.1281 29.2335 16.513 29.3034 17.9389C29.3732 19.3648 29.0701 20.7846 28.4226 22.064L23.7217 31.3408C23.4459 31.8863 23.0197 32.3456 22.4911 32.6666C21.9626 32.9877 21.3528 33.1579 20.7306 33.1579C20.1084 33.1579 19.4986 32.9877 18.97 32.6666C18.4415 32.3456 18.0153 31.8863 17.7395 31.3408L13.0478 22.064C12.4003 20.7846 12.0971 19.3648 12.167 17.9389C12.2369 16.513 12.6774 15.1281 13.447 13.9151C14.2166 12.7022 15.2897 11.7012 16.565 11.0069C17.8403 10.3126 19.2756 9.94794 20.7352 9.94736Z"
          stroke="black"
          strokeMiterlimit="10"
        />
        <path
          d="M20.7352 19.4857C22.0486 19.4857 23.1133 18.4443 23.1133 17.1597C23.1133 15.8751 22.0486 14.8338 20.7352 14.8338C19.4218 14.8338 18.3571 15.8751 18.3571 17.1597C18.3571 18.4443 19.4218 19.4857 20.7352 19.4857Z"
          stroke="black"
          strokeMiterlimit="10"
        />
      </svg>
    </span>
  );
};

export const StorePinNew = ({ brand }) => {
  return (
    <span
      className={`svg-icon-wrapper  store-icon active-brand-${brand}`}
      tabIndex="0"
      aria-label="store-icon"
      role="link"
    >
      <svg viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="21" cy="21" r="21" fill="#F5F5F5" />
        <g transform="translate(10, 10)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.5201 9.10387C4.5201 13.1975 8.80468 17.7993 11.1538 19.8576C11.8731 19.2216 13.0514 18.1142 14.216 16.7308C15.85 14.7893 17.7983 11.8902 17.7983 9.10387C17.7983 7.2371 17.1075 5.48216 15.8535 4.16214C14.5998 2.84213 12.9326 2.11532 11.1592 2.11532C7.49833 2.11532 4.5201 5.2503 4.5201 9.10387ZM3.3485 9.10387C3.3485 4.56296 6.84536 0.88205 11.1592 0.88205C15.4731 0.88205 18.9699 4.56296 18.9699 9.10387C18.9699 15.2702 11.1592 21.4366 11.1592 21.4366C11.1592 21.4366 3.3485 15.2702 3.3485 9.10387ZM8.42535 8.78756C8.42535 10.3133 9.65203 11.5545 11.1591 11.5545C12.6662 11.5545 13.8929 10.3133 13.8929 8.78756C13.8929 7.26178 12.6662 6.0206 11.1591 6.0206C9.65203 6.0206 8.42535 7.26178 8.42535 8.78756ZM7.25374 8.78756C7.25374 6.60443 9.00256 4.83476 11.1591 4.83476C13.3156 4.83476 15.0645 6.60443 15.0645 8.78756C15.0645 10.9707 13.3156 12.7404 11.1591 12.7404C9.00256 12.7404 7.25374 10.9707 7.25374 8.78756Z"
            fill="black"
          />
        </g>
      </svg>
    </span>
  );
};

export const WishlistIcon = ({ brand }) => {
  return (
    <span className={`svg-icon-wrapper wishlist-icon active-brand-${brand}`}>
      <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20" cy="20" r="20" fill="#F5F5F5" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5362 12.5705C12.5606 11.5236 13.9032 11 15.2455 11C16.5881 11 17.9303 11.5236 18.9547 12.5705L20.4385 14.087L21.7983 12.6969C22.7883 11.6848 24.0859 11.1788 25.384 11.1788C26.6816 11.1788 27.9792 11.6848 28.9692 12.6969C30.9496 14.7211 30.9496 18.0028 28.9692 20.0266L24.8894 24.1977L23.7766 25.335L20.191 29L16.4817 25.2085L15.4926 24.1977L11.5362 20.1534C9.48792 18.0593 9.48792 14.6646 11.5362 12.5705ZM18.0772 13.4288C17.3196 12.654 16.3136 12.2273 15.2455 12.2273C14.1773 12.2273 13.1718 12.654 12.4137 13.4288C10.8314 15.0463 10.8314 17.6776 12.4137 19.2951L16.3701 23.3394L17.3592 24.3503L20.191 27.245L22.8991 24.4767L24.0119 23.3394L28.0921 19.1687C29.6062 17.6211 29.6062 15.1028 28.0921 13.5552C27.3672 12.8143 26.4055 12.406 25.384 12.406C24.3625 12.406 23.4007 12.8143 22.6758 13.5552L21.3156 14.9453L20.4385 15.842L19.561 14.9453L18.0772 13.4288Z"
          fill="black"
        />
      </svg>
    </span>
  );
};
export const CartIcon = ({ brand }) => {
  return (
    <span className={`svg-icon-wrapper cart-icon active-brand-${brand}`}>
      <svg viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20.9993" cy="21" r="21" fill="#F5F5F5" />
        <path
          d="M28.328 18.6464L27.687 15.5776C27.6228 15.2875 27.4683 15.0301 27.2494 14.8486C27.0306 14.6671 26.7608 14.5725 26.4851 14.5807H15.2678C14.9921 14.5725 14.7223 14.6671 14.5034 14.8486C14.2846 15.0301 14.1301 15.2875 14.0659 15.5776L11.0853 29.3522C11.0428 29.5423 11.0408 29.7404 11.0794 29.9314C11.118 30.1224 11.1962 30.3015 11.308 30.4551C11.4199 30.6087 11.5626 30.7328 11.7252 30.8181C11.8879 30.9033 12.0663 30.9475 12.2471 30.9473H29.5058C29.6866 30.9475 29.865 30.9033 30.0277 30.8181C30.1903 30.7328 30.333 30.6087 30.4448 30.4551C30.5567 30.3015 30.6349 30.1224 30.6735 29.9314C30.7121 29.7404 30.7101 29.5423 30.6676 29.3522L28.8969 21.273L28.328 18.6464Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6696 17.0947V13.3932C16.6696 12.1862 17.1128 11.0286 17.9016 10.1751C18.6905 9.32159 19.7604 8.8421 20.8761 8.8421C21.9917 8.8421 23.0617 9.32159 23.8505 10.1751C24.6394 11.0286 25.0826 12.1862 25.0826 13.3932V17.0947"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};
export const CloseIcon = ({ brand }) => {
  return (
    <span className={`svg-icon-wrapper close-icon-mob active-brand-${brand}`}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" fill="none">
        <circle cx="18" cy="18" r="18" fill="#F5F5F5" />
        <path
          d="M18.9442 17.955L25.4452 11.4541C25.7184 11.1809 25.7184 10.7381 25.4452 10.4649C25.1724 10.1917 24.7288 10.1917 24.456 10.4649L17.955 16.9658L11.4541 10.4649C11.1812 10.1917 10.7377 10.1917 10.4649 10.4649C10.1917 10.7381 10.1917 11.1809 10.4649 11.4541L16.9659 17.955L10.4649 24.4559C10.1917 24.7291 10.1917 25.1719 10.4649 25.4451C10.6013 25.5819 10.7804 25.6501 10.9595 25.6501C11.1386 25.6501 11.3177 25.5819 11.4541 25.4451L17.955 18.9442L24.456 25.4451C24.5924 25.5819 24.7715 25.6501 24.9506 25.6501C25.1297 25.6501 25.3088 25.5819 25.4452 25.4451C25.7184 25.1719 25.7184 24.7291 25.4452 24.4559L18.9442 17.955Z"
          fill="black"
        />
      </svg>
    </span>
  );
};

export const StoreIcon = () => {
  return (
    <Image
      className="store-locator-svg"
      src={`${getImageFilePath()}/store-icon-new.svg`}
      tabIndex="0"
      aria-label="store-icon"
      role="link"
    />
  );
};

UserIcon.propTypes = {
  brand: PropTypes.string.isRequired,
};

StorePin.propTypes = {
  brand: PropTypes.string.isRequired,
};
WishlistIcon.propTypes = {
  brand: PropTypes.string.isRequired,
};
CartIcon.propTypes = {
  brand: PropTypes.string.isRequired,
};
